import { ResponseRate } from 'model/ResponseRate';
import { ResponseRateApi } from 'api/ResponseRateApi';
import dayjs from 'dayjs';

export class ResponseRateMapper {
  deserialize(entry: ResponseRateApi.Entry): ResponseRate {
    return {
      invited: entry.respondentCount,
      responses: entry.submissionCount,
      score: entry.responseRate,
      date: dayjs(entry.date),
    };
  }
}
